import React from 'react'
import Headtitle from "../../Components/HeadTitle/Headtitle"
import ContactForm from './ContactForm';

import "./Contact.scss";

function Contact() {
  return (
    <>
    <Headtitle/>
    <ContactForm/>
    </>
  )
}

export default Contact;